// Temporary Alert component until we resolve the theme differences between pro-client and ui-kit

export * from './WarningAlert';
